"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSimilarReceiver = void 0;
function createSimilarReceiver(response) {
    return {
        eventId: response.eventId,
        playerId: response.similarPlayer.playerId,
        teamId: response.similarPlayer.teamId,
        overallSimilarity: response.similarPlayer.overallSimilarity,
        stats: response.similarPlayer.stats,
    };
}
exports.createSimilarReceiver = createSimilarReceiver;
//# sourceMappingURL=similar_receivers_request.js.map